
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pay/signup",
      function () {
        return require("private-next-pages/pay/signup/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pay/signup"])
      });
    }
  